import React from 'react';
import { formatDate, oddToString, getConfiguration } from '../../../data/utils';
import { getLabel } from '../../../data/labels';

function BorderedTicketSelections(props) {
	const ticketData = props.ticketData;
	const selections = ticketData.events;
	const purchaseType = ticketData.purchaseType;
	const conf = getConfiguration();
	const baseSymb = getLabel('ticket.system.base_symb');
	const varSymb = getLabel('ticket.system.var_symb');
	
	let liveSymbol = getLabel('ticket.live_symbol').length > 0 ? '[' + (getLabel('ticket.live_symbol') + '] ') : null;
	if (!liveSymbol && getLabel('general.live').length > 0) {
		const liveLabel = getLabel('general.live');
		if (liveLabel.length > 0) {
			liveSymbol = ['[', liveLabel.charAt(0).toUpperCase(), ']', ' '].join('');
		}
	}
	
	if(!liveSymbol){
		liveSymbol = '[L] ';
	}
	
	
	function isLastSelections(i){
		return selections.length === (i + 1);
	}
	return (
        <>
            {selections.map(function(selection, selectionIndex) {
                let uniqueId = selection.alias;
                const printPalAvv = (!uniqueId || uniqueId.length === 0) || conf.ppat;
                if (printPalAvv) {
                    uniqueId = selection.pal + "." + selection.avv;
                }
                let descManif = ''
                if (selection.descCategory != null && selection.descCategory.length > 0) {
                    descManif = selection.descCategory;
                }
                if (selection.descTournament != null && selection.descTournament.length > 0) {
                    descManif = descManif + " " + selection.descTournament;
                }
                
                const banker = purchaseType === 'systembets'?(selection.fixed? baseSymb : varSymb) : '';
                
                const reactKey = 'ticket-selection-' + selection.pal + "-" + selection.avv;
                const bets = selection.bets;
                const eventDate = formatDate(selection.timestamp).formatted;
                return <React.Fragment key={reactKey}>
                    <div className="event-subtable">
                        <div className="event-row">
                            <div className="event-row-left">{selection.descSport}</div>
                            <div className="event-row-right">{eventDate}</div>
                            <div className="clear"></div>
                        </div>
                        <div className="event-row">
                            <div className="event-row-left ellipsis-if-overflow">{descManif}</div>
                            <div className="event-row-right">{uniqueId}</div>
                            <div className="clear"></div>
                        </div>
                        <div className="event-row">
                            <div className="event-row-left event-name">
                                {banker.length > 0 &&
                                    <span className="banker">{banker}</span>
                                }
                                <span>{conf.plit && selection.liveWhilePurchase? liveSymbol: "" }{selection.descAvv}</span>
                            </div>
                            <div className="clear"></div>
                        </div>
                        {bets.map(function(bet) {
                            const betReactKey = reactKey + '-bet-' + bet.scomSogei + '-' + bet.handicap + '-' + bet.codDraw;
                            const odd = oddToString(bet.odd);
                            return (
                                <div key={betReactKey} className="event-row">
                                    <div className="event-row-left">
                                        {bet.printableDescScom} - 
                                        <span className="draw">{bet.printableDescDraw}</span>
                                    </div>
                                    <div className="event-row-right bold">{odd}</div>
                                    <div className="clear"></div>
                                </div>
                            );
                        })}
                    </div>
                    {!isLastSelections(selectionIndex) &&
                        <div className="table-line"></div>
                    }
                </React.Fragment>
            })}	
        </>
    );
}

export default BorderedTicketSelections;